import { useAppChatStore } from '@/entities/AppChat/model/store';

/** Получает количество непрочитанных сообщений поддержки приложения */
export const useUnreadMessages = (enabled = true): number => {
    const count = useAppChatStore((state) => state.counters?.unreadMessages ?? 0);

    return enabled
        ? count
        : 0;
};
